import { FC, useRef } from "react";
import { InfoIcon } from '@chakra-ui/icons';
import {
  Grid,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogOverlay,
  Button,
  ButtonGroup,
  Text,
  Heading, VStack, GridItem,
} from "@chakra-ui/react";

type Props = {
  isOpen: boolean,
  onClose: () => void,
  onClick: () => void,
  primaryButtonText: string;
  content: string;
  title: string;
}

export const InfoDialog: FC<Props> = ({ isOpen, onClose, content, title, onClick, primaryButtonText }) => {
  const cancelRef = useRef();

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      size={"lg"}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogBody pt={7}>
          <Grid
            width={"100%"}
            columnGap={4}
            templateColumns={"26px auto"}
            justifyContent={"start"}
          >
            <GridItem>
              <InfoIcon boxSize={'26px'} color={'blue.500'} />
            </GridItem>
            <GridItem>
              <VStack width={"100%"} spacing={4}>
                <Heading size={"md"} width={"100%"} mt={"2px"}>{ title }</Heading>
                <Text size={"md"} variant={"secondary"} width={"100%"}>
                  { content }
                </Text>
              </VStack>
            </GridItem>
          </Grid>
        </AlertDialogBody>
        <AlertDialogFooter pt={3}>
          <ButtonGroup>
            <Button ref={cancelRef} onClick={onClose}>Close</Button>
            <Button variant="primary" onClick={onClick}>{ primaryButtonText }</Button>
          </ButtonGroup>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}